import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { A3LCompany } from '../../../core/models/a3LCompany.model';
import { A3LEmployee } from '../../../core/models/a3LEmployee.model';
import { A3LCompanyService } from '../../../core/services/a3LCompany.service';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-A3LEmployees-List',
  templateUrl: './A3LEmployees-List.component.html',
  styleUrls: ['./A3LEmployees-List.component.scss'],
  providers: [A3LCompanyService, A3LEmployeeService, UserService]
})
export class A3LEmployeesListComponent extends ListFormBase<A3LEmployee>
implements OnInit {

     // Propiedades del panel contenedor
     panelIcon = 'person'; // Material icon
     panelTitle = 'Empleados';
     panelDescription = 'Listado de los empleados de la empresa seleccionada';

     @Output() onCreateA3LaboralUser: EventEmitter<any> = new EventEmitter();

     a3LaboralCompany: number;
     a3LaboralCompanies: A3LCompany[];
     a3LaboralEmployees: A3LEmployee[];

     constructor(
       protected _modelService: A3LEmployeeService,
       protected _a3LCompanyService: A3LCompanyService,
       protected _userService: UserService,
       protected _router: Router,
       protected _route: ActivatedRoute,
       protected _messageDialog: MessageDialog
     ) {
       super(_modelService, _router, _route, _messageDialog, A3LEmployee);
       this.isCrud = false;
       this.loadA3LCompanies();
     }

    ngOnInit(): void {}

    onA3LCompanySelectChange(e) {
      this.dataGrid.instance.clearSelection();
      this.loadDataSource(e.value);
    }

    onButtonGenerateUserClick(){
      this._userService.generateA3LUsers({CompanyCode: this.a3LaboralCompany, EmployeesCode: this.dataGrid.instance.getSelectedRowKeys()}).subscribe(res =>
        {
          this.onCreateA3LaboralUser.emit();
          this.dataGrid.instance.clearSelection();
          this.dataGrid.instance.clearFilter();
          this.loadDataSource(this.a3LaboralCompany);
        }
      );
    }

    loadDataSource(companyCode){
      this.getCustomDataSource("employeeCode", companyCode);
    }

    loadA3LCompanies(){

      let params: HttpParams = new HttpParams();

      params = params.set('$orderby',  `companyName asc`);
      params = params.set('$filter', `companyCode eq 574 or companyCode eq 531`)

      this._a3LCompanyService.getAllModels(null,params).subscribe(res => (this.a3LaboralCompanies = res));
    }



}
